
export default class SimpleChoice
{
    id: string|number;
    name: string;
    slug: string = "";

    constructor(id:string|number, name:string)
    {
        this.id = id;
        this.name = name;
    }
}

export type ISimpleChoices = {
    [key in string]: SimpleChoice
};